<template>
	<div>
		<div class="fullPageContent closed">
			<DashboardHeader 
				v-bind:title="pageTitle" 
				v-bind:activeEl="activeEl"
				v-bind:tabs="tabs"
				@tabSelectedChange="tabSelectedChange($event)"
				ref="dashboardHeader"
			/>
			<section class="allP awards wp1200">
				<div class="content">
					<div v-if="isActive === 1">
						<Awards></Awards>
					</div>
					<div v-if="isActive === 2">
						<Charity></Charity>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
import DashboardHeader from "./partials/DashboardHeader.vue";
import Awards from "./Awards/Awards.vue";
import Charity from "./Awards/Charity.vue";

export default {
	data() {
		return {
			activeEl:3,
			pageTitle:this.$t("dashboard.points"),
			tabs:[
				{
					index:1,
					name:'Nagrade'
				},
				{
					index:2,
					name:'Dobrodelnost'
				}
			],
			isActive:1,
		};
	},
	computed: {},
	components: {
		DashboardHeader,
		Awards,
		Charity,
	},
	mounted() {
		this.$store.dispatch("app/loader", false);
		this.charityActive();
	},
	methods: {
		charityActive(){
			if(this.$route.query.page === 'charity'){
				this.tabSelectedChange(2);
				this.$refs.dashboardHeader.tabActive = 2;
			}
		},
		tabSelectedChange(active) {
			this.isActive = active;
		},
	}
};
</script>

<style>
.vue-typer .custom.char.typed {
	color: #ffffff;
}
.vue-typer .custom.caret {
	display: none;
}
</style>